import { callGetAPI } from "./BaseService";

export const sliderContent = async () => {
    const response = await callGetAPI('slider_content');
    return response;
}

export const aboutUs = async () => {
    const response = await callGetAPI('aboutus');
    return response;
}

export const faqList = async () => {
    const response = await callGetAPI('faqs');
    return response;
}
